import _extends from "@babel/runtime/helpers/esm/extends";
import { getRecurringEventOccurrencesForVisibleDays } from "./recurring-events/index.mjs";
export function generateOccurrenceFromEvent({
  event,
  eventId,
  occurrenceKey,
  start,
  end
}) {
  return _extends({}, event, {
    id: eventId,
    key: occurrenceKey,
    displayTimezone: _extends({}, event?.displayTimezone, {
      start,
      end
    }),
    dataTimezone: _extends({}, event?.dataTimezone, {
      start,
      end
    })
  });
}

/**
 *  Returns the key of the days an event occurrence should be visible on.
 */
export function getDaysTheOccurrenceIsVisibleOn(event, days, adapter) {
  const eventStartStartOfDay = adapter.startOfDay(event.displayTimezone.start.value);
  const eventEndEndOfDay = adapter.endOfDay(event.displayTimezone.end.value);
  const dayKeys = [];
  for (const day of days) {
    // If the day is before the event start, skip to the next day
    if (adapter.isBefore(day.value, eventStartStartOfDay)) {
      continue;
    }

    // If the day is after the event end, break as the days are sorted by start date
    if (adapter.isAfter(day.value, eventEndEndOfDay)) {
      break;
    }
    dayKeys.push(day.key);
  }
  return dayKeys;
}

/**
 * Returns the occurrences to render in the given date range, expanding recurring events.
 */
export function getOccurrencesFromEvents(parameters) {
  const {
    adapter,
    start,
    end,
    events,
    visibleResources,
    displayTimezone,
    plan
  } = parameters;
  const occurrences = [];
  for (const event of events) {
    // STEP 1: Skip events from resources that are not visible
    if (event.resource && visibleResources[event.resource] === false) {
      continue;
    }

    // STEP 2-A: Recurrent event processing, if it is recurrent expand it for the visible days
    if (event.displayTimezone.rrule) {
      // In community, recurring events are not expanded into occurrences.
      // They are treated as single non-recurring events.
      if (plan !== 'premium') {
        if (adapter.isAfter(event.displayTimezone.start.value, end) || adapter.isBefore(event.displayTimezone.end.value, start)) {
          continue;
        }
        occurrences.push(_extends({}, event, {
          key: String(event.id)
        }));
        continue;
      }

      // TODO: Check how this behave when the occurrence is between start and end but not in the visible days (e.g: hidden week end).
      occurrences.push(...getRecurringEventOccurrencesForVisibleDays(event, start, end, adapter, displayTimezone));
      continue;
    }

    // STEP 2-B: Non-recurring event processing, skip events that are not within the visible days
    if (adapter.isAfter(event.displayTimezone.start.value, end) || adapter.isBefore(event.displayTimezone.end.value, start)) {
      continue;
    }
    occurrences.push(_extends({}, event, {
      key: String(event.id)
    }));
  }
  return occurrences;
}